<template>
  <div>
    <v-card
      flat
      :loading="loading"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-text class="black--text ">
        <div class="mx-12">
          <naj-item-description
            :title="local.caseFile.caseSubject"
            :message="caseDetails.caseSubject"
            :no-data-message=" local.caseFile.noCaseSubject"
          >
          </naj-item-description>

          <naj-item-description
            :title="local.caseFile.caseDemands"
            :message="caseDetails.caseDemands"
            :no-data-message=" local.caseFile.noCaseDemands"
          >
          </naj-item-description>

          <naj-item-description
            :title="local.caseFile.caseProofs"
            :message="caseDetails.caseProofs"
            :no-data-message=" local.caseFile.noCaseProofs"
          >
          </naj-item-description>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'CaseDetailsTab',
  components: {},
  props: {
    caseDetails: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {},
};

</script>
<style lang="scss" scoped>
</style>
